import { SHOW_TOAST, HIDE_TOAST } from '../../types';

export const hideToast = () => (dispatch) => {
  dispatch({ type: `${HIDE_TOAST}` });
};

export const showToast =
  (type, message, delay = 4000) =>
  (dispatch) => {
    dispatch(hideToast());
    dispatch({
      type: SHOW_TOAST,
      payload: { type, message: message, delay: delay }
    });
  };
